// extracted by mini-css-extract-plugin
export default {"zone":"CashRain_zone__tqTlF","note":"CashRain_note__po-hj","cash-fall":"CashRain_cash-fall__EPQlg"};